import { inputFields, tables, Buttons } from "../../components";

const Checklists = ({ state, setState, setActiveTab }) => {
  const handleChecklistChange = (index, field, value) => {
    const updatedChecklists = [...state.checklists];
    updatedChecklists[index][field] = value;
    setState({ ...state, checklists: updatedChecklists });
  };

  const addChecklist = () => {
    const newChecklist = {
      title: "",
      details: "",
    };
    setState({
      ...state,
      checklists: [...state.checklists, newChecklist],
    });
  };

  const removeChecklist = (index) => {
    const updatedChecklists = state.checklists.filter((_, i) => i !== index);
    setState({ ...state, checklists: updatedChecklists });
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleChecklistChange(index, "title", e.target.value)
          }
        />
      ),
    },
    {
      title: "Details",
      dataIndex: "details",
      width: 350,
      render: (text, record, index) => (
        <inputFields.DefaultTextbox
          value={text}
          onChange={(e) =>
            handleChecklistChange(index, "details", e.target.value)
          }
        />
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton
            size="medium"
            onClick={() => removeChecklist(index)}
          >
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={state.checklists}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
        />
      </div>
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton size="medium" onClick={addChecklist}>
          Add Checklist
        </Buttons.DefaultButton>

        <Buttons.DefaultButton size="medium" onClick={() => setActiveTab("8")}>
          Next
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default Checklists;
